import { Navigate, useLocation } from "react-router-dom";
import { MAP_URL } from "../config/map-urls";

/**
 * The map moved from `/map` to `/`. Existing links and bookmarks keep working;
 * query string and hash are carried over so a deep link still lands where it
 * pointed. `replace` keeps the dead path out of the history stack.
 */
export default function LegacyMapRedirect() {
  const { search, hash } = useLocation();
  return <Navigate to={`${MAP_URL.ROOT}${search}${hash}`} replace />;
}
